export const SET_SORT_AND_FILTER_FOR_MESSAGES = 'SET_SORT_AND_FILTER_FOR_MESSAGES'
